export default "__VITE_ASSET__DhyoZWgh__"